export default "__VITE_ASSET__CIkex_tw__"